import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import ProyectosScreen from './screen';
import { ProyectosAdapter, Proyecto } from '../../../../infraestructure/persistence/rest/ProyectosAdapter';
import { useNotifications } from '../../../../shared/hooks/Notifications';

const _defaultState = {isLoading:false,label:``}

const ProyectosContainer = () => {

	const api = new ProyectosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ proyectos, setProyectos ] = useState<any>([]);
	let [loadState, setLoadState] = useState(_defaultState);
	let result: any;

	useEffect(() => {
		getProyectos();
	}, []);

	useEffect(() => {}, [ proyectos ]);

	const getProyectos = async () => {
		setLoadState({isLoading:true,label:`Cargando Proyectos...`});
		try {
			result = await api.ListarProyectos();
			if(result.data && result.data!=="")
			{
				setProyectos([ ...result.data ]);
			}else{resultError()}
			setLoadState(_defaultState);
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception);
			setLoadState(_defaultState);
		}
	};

	const createProyecto = async (proyecto: any) => {
		setLoadState({isLoading:true,label:`Creando Proyecto...`});
		try {
			result = await api.CrearProyecto(proyecto);
			if(result.data && result.data!=="")
			{
				setProyectos([ ...proyectos,...result.data ]);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado un nuevo proyecto."})
			}else{resultError()}
			setLoadState(_defaultState);
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
			setLoadState(_defaultState);
		}
	};

	const deleteProyecto = async (idProyecto: number) => {
		setLoadState({isLoading:true,label:`Eliminando Proyectos...`});
		try {
			result = await api.EliminarProyecto(idProyecto);
			if(result.data && result.data!=="")
			{
				let pos = proyectos.findIndex((p: Proyecto) => p.idProyecto === idProyecto);
				let newData = [ ...proyectos ];
				newData.splice(pos, 1);
				setProyectos([ ...newData ]);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado unproyecto."})
			}else{resultError()}
			setLoadState(_defaultState);
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setLoadState(_defaultState);
		}
	};

	const updateProyecto = async (proyecto: Proyecto) => {
		setLoadState({isLoading:true,label:`Actualizando Proyecto...`});
		try {
			result = await api.ModificarProyecto(proyecto);
			if(result.data && result.data!=="")
			{
				let pos = proyectos.findIndex((p: Proyecto) => p.idProyecto === proyecto.idProyecto);
				let newData = [ ...proyectos ];
				newData[pos] = result.data[0];
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un proyecto."})
				setProyectos([ ...newData ]);
			}else{resultError()}
			setLoadState(_defaultState);
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setLoadState(_defaultState);
		}
	};

	return (
		<ProyectosScreen
			data={proyectos}
			loadState={loadState}
			handleCreate={createProyecto}
			handleRemove={deleteProyecto}
			handleUpdate={updateProyecto}
		/>
	);
};

export default ProyectosContainer;
